module.exports = __webpack_public_path__ + "static/media/card_background.fbccc437.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/card_background.jpg
// module id = 1027
// module chunks = 0